import { Dict } from "app/utils/Dict";
import React from "react";
import { useEffect } from "react";
import { EntitesDadosEstoque } from "../Estoque/Estoque";
import { EstoqueContainer, EstoqueContainerProps } from "../Estoque/EstoqueContainer";
import {
  removerComponenteReact,
  renderizarComponentReact,
} from "../renderizarOuRemoverComponentReact";
import { MenuSubConsultaProdutoContainer } from "./MenuSubConsultaProdutoContainer";

export function useMenuSubConsulta(
  propsEstoque: EstoqueContainerProps
) {
  const onRenderizarSubConsultaReact = (estoqueSelecionado?: EntitesDadosEstoque, passos?: Dict<string, () => void>) => {
    renderizarComponentReact(
      <MenuSubConsultaProdutoContainer
        //dadosEstoque={propsEstoque.dadosEstoque}
        estoqueSelecionado={estoqueSelecionado ?? propsEstoque.estoqueSelecionado}
        item={propsEstoque.item}
        onSelecionadoMenu={() => $("[container]").hide()}
        onVoltar={() =>
          renderizarComponentReact(
            <EstoqueContainer
              {...propsEstoque}
              estoqueSelecionado={estoqueSelecionado ?? propsEstoque.estoqueSelecionado}
            />,
            "conteudo-pagina",
            true
          )
        }
        passos={passos ?? propsEstoque.passos}
        foraOrcamento={propsEstoque.foraOrcamento}
      />,
      "menu-sub-consulta-produtos-react"
    );
  };

  useEffect(() => {
    setTimeout(() => onRenderizarSubConsultaReact());
    return () => {
      removerComponenteReact("menu-sub-consulta-produtos-react");
    };
  }, []);

  return onRenderizarSubConsultaReact
}
